import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery, navigate } from 'gatsby';

import { BlogView } from './view';
import { generateSlug } from 'utilities/helpers/generateSlug';
import { paths } from 'utilities/routes';
import { locationShape } from 'utilities/data/proptypesShapes';
import _ from 'lodash';

export const URL_PARAMS_SEARCH_NAME = 'search';

export const Blog = ({
    type, page, location, tag
}) => {
    const data = useStaticQuery(graphql`
        query {
            allArticles(filter: { is_active: { eq: 1 } }) {
                nodes {
                    slug
                    type
                    alternative_id
                    promoted_active
                    title
                    created_at
                    reading_time
                    image_main
                    lead
                    tags
                }
            }
        }
    `)?.allArticles?.nodes;

    const searchParams = new URLSearchParams(location.search);
    const articlesSearchQuery = searchParams.get(URL_PARAMS_SEARCH_NAME) || '';
    const uniqueTags = Array.from(new Set(data.map((d) => d.tags).flat()));

    const types = [...new Set(data.map((currentValue) => currentValue.type))];

    const [currentPage, setCurrentPage] = useState(() => +page || 1);

    useEffect(() => {
        if (type !== 'wszystkie' && !types.map((currentValue) => generateSlug(currentValue)).includes(type)) {
            navigate(paths.wszystkoODrzwiach);
        }
    }, []);

    useEffect(() => {
        setCurrentPage(+page || 1);
    }, [page]);

    const filteredPosts = data.filter((currentValue) => {
        if (type === 'wszystkie') {
            const tags = currentValue.tags.map((t) => generateSlug(t));
            const filterByTag = tag ? tags.includes(tag) : true;
            return filterByTag && _.includes(currentValue.title.toLowerCase(), articlesSearchQuery.toLowerCase());
        }
        const tags = currentValue.tags.map((t) => generateSlug(t));
        const filterByTag = tag ? tags.includes(tag) : true;
        const filterByType = _.includes(generateSlug(currentValue?.type), type);
        const filterByTitle = _.includes(currentValue.title.toLowerCase(), articlesSearchQuery.toLowerCase());
        const filterByLead = _.includes(currentValue.lead.toLowerCase(), articlesSearchQuery.toLowerCase());
        const isPromotedActive = currentValue.promoted_active === 0;

        return filterByType && filterByTag && (filterByTitle || filterByLead) && isPromotedActive;
    });

    return (
        <BlogView
            types={ types }
            posts={ filteredPosts || [] }
            currentType={ type }
            currentPage={ currentPage }
            location={ location }
            tags={ uniqueTags }
            currentTag={ tag }
        />
    );
};

Blog.propTypes = {
    type: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
    location: PropTypes.shape(locationShape).isRequired,
    tag: PropTypes.string.isRequired
};
